import React from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import FeedTab from "./FeedTab";
import TimetableTab from "./TimetableTab";

const Navigation = () => {
  return (
    <Tabs my={5} isFitted size="lg" colorScheme="red" w="full">
      <TabList>
        <Tab>Live Feed</Tab>
        <Tab>Timetable</Tab>
      </TabList>

      <TabPanels>
        <TabPanel>
          <FeedTab />
        </TabPanel>
        <TabPanel>
          <TimetableTab />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default Navigation;
